export default __webpack_public_path__ + "static/media/311-data.dd9816bc.gif";